'use client';

import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useState
} from 'react';

export type productContextType = {
  selectedProduct: string;
  setSelectedProduct: Dispatch<SetStateAction<string>>;
  selectedWorkload: string;
  setSelectedWorkload: Dispatch<SetStateAction<string>>;
};

export const productContext = createContext<productContextType>({
  selectedProduct: '',
  setSelectedProduct: () => {},
  selectedWorkload: '',
  setSelectedWorkload: () => {},
});

export const ProductContextProvider = ({
  children
}: {
  children: ReactNode;
}) => {

  const [selectedProduct, setSelectedProduct] = useState<string>('H200');
  const [selectedWorkload, setSelectedWorkload] = useState<string>('Compute');

  return (
    <productContext.Provider
      value={{
        selectedProduct,
        setSelectedProduct,
        selectedWorkload,
        setSelectedWorkload,
      }}>
      {children}
    </productContext.Provider>
  );
};
